/* Base */

.eds-connector {
  block-size: var(--eds--size-1);
  display: block;
  flex-shrink: 0;
  inline-size: 100%;
}

/* Direction */

.eds-connector--direction-vertical {
  block-size: 100%;
  inline-size: var(--eds--size-1);
}

/* States */

.eds-connector--completed {
  background: var(--eds--color--bg-positive-strong);
}

.eds-connector--current {
  background: linear-gradient(
    to right,
    var(--eds--color--bg-positive-strong),
    var(--eds--color--border-brand)
  );
}

.eds-connector--current.eds-connector--direction-vertical {
  background: linear-gradient(
    to bottom,
    var(--eds--color--bg-positive-strong),
    var(--eds--color--border-brand)
  );
}

.eds-connector--future {
  background: repeating-linear-gradient(
    to right,
    var(--eds--color--border-default) 0 var(--eds--size-8),
    transparent var(--eds--size-8) var(--eds--size-16)
  );
}

.eds-connector--future.eds-connector--direction-vertical {
  background: repeating-linear-gradient(
    to bottom,
    var(--eds--color--border-default) 0 var(--eds--size-8),
    transparent var(--eds--size-8) var(--eds--size-16)
  );
}
